module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "session-edit-box"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l((_vm.student.sessions), function(session) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "name is-inline-block"
    }, [_vm._v(_vm._s(_vm.sessionToString(session)))])]), _c('td', [_c('button', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          _vm.showDeleteWarning(session)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }))]), (_vm.sessionToDelete) ? _c('remove-warning', {
    attrs: {
      "object": "session",
      "name": _vm.toDeleteName
    },
    on: {
      "close": _vm.removeWarningClosed
    }
  }) : _vm._e(), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c82dcd74"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/SessionEditBox.vue
// module id = 447
// module chunks = 0